import PurebrandLoader from "components/Loader/PurebrandLoader";
import CustomModal from "components/Modal/CustomModal";
import AuthContext from "context/AuthContext";
import DataContext from "context/DataContext";
import React, { useContext, useState } from "react";
import useCan from "hooks/useCan";
import { extractErrorMessage } from "utils/apiErrors";
import { CAPABILITIES } from "utils/capabilities";
import { getRoleByValue } from "utils/constants";

const ViewAdminList = ({ adminList }) => {
  const { reAssignNewRole, updateAssignedRole, getAssignedRole } =
    useContext(DataContext);
  const { user } = useContext(AuthContext);
  // Same backend-provided list the invite form uses.
  const { assignableRoles, can } = useCan();
  const canManageTeam = can(CAPABILITIES.TEAM_MANAGE);
  const [show, setShow] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [failed, setFailed] = useState(false);
  const [failureMessage, setFailureMessage] = useState("");
  const [editRole, setEditRole] = useState(false);
  const [roleId, setRoleId] = useState(adminList?.role);
  const [loading, setLoading] = useState(false);

  // The backend refuses self role changes; don't offer the button.
  const isSelf = adminList?.id === user?.uid;
  const roleLabel =
    assignableRoles.find((option) => option.value === adminList?.role)?.label ??
    getRoleByValue(adminList?.role)?.label ??
    "";

  const handleClose = () => {
    setShow(false);
  };

  const handleCloseToast = () => {
    setShowToast(false);
  };

  const reinviteHandle = async () => {
    setLoading(true);
    setFailed(false);
    try {
      const res = await reAssignNewRole(adminList.id);
      if (res.status === 200) {
        setShow(true);
      }
    } catch (error) {
      setFailed(true);
      setFailureMessage(extractErrorMessage(error));
      setShow(true);
    } finally {
      setLoading(false);
    }
  };

  const updateAssignedRoleHandle = async () => {
    if (Number(roleId) === adminList.role) {
      setEditRole(false);
      return;
    }
    setLoading(true);
    setFailed(false);
    try {
      const res = await updateAssignedRole(Number(roleId), adminList.id);
      if (res.status === 200) {
        setShowToast(true);
        setEditRole(false);
        await getAssignedRole(`?order=true`);
      }
    } catch (error) {
      setFailed(true);
      setFailureMessage(extractErrorMessage(error));
      setShowToast(true);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <tr>
        <td colSpan={4}>
          <PurebrandLoader />
        </td>
      </tr>
    );
  }

  return (
    <>
      <CustomModal
        showStatus={show}
        clickStatus={handleClose}
        buttonMessage="Close"
        closeStatus={handleClose}
        title={!failed ? "Success" : "Failed"}
        message={!failed ? "Re-Invitation mail has been sent." : failureMessage}
        secondButton={false}
        secondMessage="none"
      />

      <CustomModal
        showStatus={showToast}
        clickStatus={handleCloseToast}
        buttonMessage="Close"
        closeStatus={handleCloseToast}
        title={!failed ? "Success" : <p className="text-danger h4"> Failed</p>}
        message={!failed ? "Role updated." : failureMessage}
        secondButton={false}
        secondMessage="none"
      />

      <tr>
        <td>
          {adminList?.first_name} {adminList?.last_name}
          {isSelf && <span className="text-muted"> (you)</span>}
        </td>
        <td>{adminList?.email}</td>
        <td>
          {!editRole ? (
            roleLabel
          ) : (
            <select
              className="form-select"
              value={roleId}
              onChange={(e) => {
                setRoleId(e.target.value);
              }}
            >
              {assignableRoles.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          )}
        </td>
        <td>
          {canManageTeam && !isSelf && (
            <button
              className="btn bg-danger text-white m-1"
              onClick={() => {
                setRoleId(adminList.role);
                setEditRole(!editRole);
              }}
            >
              {editRole ? "Cancel" : "Edit"}
            </button>
          )}

          {canManageTeam && !editRole && (
            <button
              className="btn bg-primary text-white m-1"
              hidden={adminList?.has_signed_up === true}
              onClick={reinviteHandle}
            >
              Reinvite
            </button>
          )}
          {canManageTeam && editRole && (
            <button
              className="btn bg-primary text-white m-1"
              onClick={updateAssignedRoleHandle}
            >
              Update
            </button>
          )}
        </td>
      </tr>
    </>
  );
};

export default ViewAdminList;
